import React from 'react'
import { useSelector } from "react-redux";
import AllocationInfo from '../../../../../containers/UserInfo/SideWindowInfo/AllocationInfo';

const AllocationManagementInfoStep = (props) => {
  const allocations = useSelector((state) => state.allocations.allocations);

  let selectedAllocationToManage = props?.selectedAllocationToManage;
  let foundedAllocation = allocations.find(allocation => allocation.id === selectedAllocationToManage.id);

 /*let foundedAllocation = selectedAllocationToManage?.id 
    ? allocations.find(allocation => allocation.id === selectedAllocationToManage.id)
    : undefined;
  
  // If not found in Redux, fall back to assignedParkerAllocations from props
  // This handles the case where allocation was removed from Redux but still exists in local state
  if (!foundedAllocation && selectedAllocationToManage?.id) {
    foundedAllocation = props?.assignedParkerAllocations?.find(
      allocation => allocation.id === selectedAllocationToManage.id
    );
  }*/

  const updateActivationParkerAllocation = (allocation) => {
    let assignedIndexToUpdate = props?.assignedParkerAllocations?.findIndex(assign => assign.id === allocation.id);
    let assignedParkerAllocationsCopy = [...props?.assignedParkerAllocations];
    let allocationToUpdate = {...assignedParkerAllocationsCopy[assignedIndexToUpdate]};
    allocationToUpdate.isActive = allocation.isActive;
    assignedParkerAllocationsCopy[assignedIndexToUpdate] = allocationToUpdate;

    // updates allocations list on ui
    props?.handleChange({["assignedParkerAllocations"] : assignedParkerAllocationsCopy});
  };

  const updateAssignedParkerAllocation = (allocation) => {
    // edit - when fob-supported 
    let assignedIndexToUpdate = props?.assignedParkerAllocations?.findIndex(assign => assign.id === allocation.id);
    let assignedParkerAllocationsCopy = [...props?.assignedParkerAllocations];
    let allocationToUpdate = {...assignedParkerAllocationsCopy[assignedIndexToUpdate]};
    allocationToUpdate.fob = allocation.fob;
    assignedParkerAllocationsCopy[assignedIndexToUpdate] = allocationToUpdate;

    // updates allocations list on ui
    props?.handleChange({["assignedParkerAllocations"] : assignedParkerAllocationsCopy});
  };

  const deleteAssignedParkerAllocation = (deletedAllocationId) => {
    let assignedIndexToDelete = props?.assignedParkerAllocations?.findIndex(assign => assign.id === deletedAllocationId);
    let assignedParkerAllocationsCopy = [...props?.assignedParkerAllocations];

    // remove only if founded
    if (assignedParkerAllocationsCopy[assignedIndexToDelete]) {
      assignedParkerAllocationsCopy.splice(assignedIndexToDelete, 1);
    }

    // updates allocations list on ui
    props?.handleChange({["assignedParkerAllocations"] : assignedParkerAllocationsCopy});
  };

  // Handle tokens actions
  const updateActivationAssignedParkerAllocationsByTokenId = (updatedTokenId) => {
    let assignedIndexToUpdate = props?.assignedParkerAllocations?.findIndex(assign => assign.tokenId === updatedTokenId);
    let assignedParkerAllocationsCopy = [...props?.assignedParkerAllocations];
    let allocationToUpdate = {...assignedParkerAllocationsCopy[assignedIndexToUpdate]};
    allocationToUpdate.isActive = !allocationToUpdate.isActive;
    assignedParkerAllocationsCopy[assignedIndexToUpdate] = allocationToUpdate;

    // updates allocations list on ui
    props?.handleChange({["assignedParkerAllocations"] : assignedParkerAllocationsCopy});
  };

  const deleteAssignedParkerAllocationsByTokenId = (deletedTokenId) => {
    // remove the allocations to delete by filter difference by deletedTokenId
    let assignedParkerAllocationsCopy = props?.assignedParkerAllocations?.filter(assign => assign.token.id !== deletedTokenId);

    // updates allocations list on ui
    props?.handleChange({["assignedParkerAllocations"] : assignedParkerAllocationsCopy});
  };

  return (
    <>
        {foundedAllocation === undefined ? 
        (<h6>Allocation not founded</h6>) 
        :
        (
            <AllocationInfo
                {...foundedAllocation}
                updateActivationParkerAllocation={updateActivationParkerAllocation}
                updateAssignedParkerAllocation={updateAssignedParkerAllocation}
                deleteAssignedParkerAllocation={deleteAssignedParkerAllocation}
                updateActivationAssignedParkerAllocationsByTokenId={updateActivationAssignedParkerAllocationsByTokenId}
                deleteAssignedParkerAllocationsByTokenId={deleteAssignedParkerAllocationsByTokenId}
                isAddAllocationProcess={props?.isAddAllocationProcess}
                handleStateDataChange={props?.handleStateDataChange}
                validRole={props?.validRole}
            ></AllocationInfo>    
        )
        }

        {/* <AllocationInfo
            {...foundedAllocation}
            updateActivationParkerAllocation={updateActivationParkerAllocation}
            updateAssignedParkerAllocation={updateAssignedParkerAllocation}
            deleteAssignedParkerAllocation={deleteAssignedParkerAllocation}
            updateActivationAssignedParkerAllocationsByTokenId={updateActivationAssignedParkerAllocationsByTokenId}
            deleteAssignedParkerAllocationsByTokenId={deleteAssignedParkerAllocationsByTokenId}
            isAddAllocationProcess={props?.isAddAllocationProcess}
            handleStateDataChange={props?.handleStateDataChange}
        ></AllocationInfo> */}
    </>
  )
};

export default AllocationManagementInfoStep;